// src/pages/AboutUs.jsx

import React, { useEffect, useState, useCallback, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import MagicParticles from "../index/MagicParticles";
import Footer from "../index/Footer";
//import SimpleBar from 'simplebar-react';
//import 'simplebar-react/dist/simplebar.min.css';
import Header from "../index/Header";



export default function AboutUs() {

  const [index, setIndex] = useState(0);

  const team = [
    {
      name: "Esperanza",
      title: "Arquitecta de sueños",
      description:
        "Especialista en imaginar lo imposible. Esperanza transforma cada idea en una vivencia sensorial que hechiza a quien la vive.",
      image: "/img/esperanza.jpg",
    },
    {
      name: "Tamara",
      title: "Guardiana del Encanto",
      description:
        "Custodia la magia en cada detalle. Su pasión es convertir un momento ordinario en algo inolvidable.",
      image: "/img/tamara.jpg",
    },
    {
      name: "Mónica",
      title: "Maestra de Ceremonias",
      description:
        "Planificadora nata, Mónica mezcla elegancia y fantasía en cada evento. Nada se le escapa en su reino de ilusiones.",
      image: "/img/monica.jpg",
    },
  ];

  const [hovered, setHovered] = useState(null);
  const scrollRef = useRef();

  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("/api/newsletter", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ nombre: "", email }),
      });

      if (res.ok) {
        setSuccess(true);
        setError(null);
        setEmail("");
      } else {
        const data = await res.json();
        setError(data.message || "Error al suscribirse");
      }
    } catch (err) {
      setError("Error de conexión");
    }
  };
  useEffect(() => {
    let timer;
    if (success || error) {
      timer = setTimeout(() => {
        setSuccess(false);
        setError(null);
      }, 2400);
    }

    return () => clearTimeout(timer);
  }, [success, error]);

  return (
    //<SimpleBar ref={scrollRef} style={{ maxHeight: '100vh' }} autoHide={false}>

    <main className="font-cinzel bg-eryndra-burgundy text-eryndra-cream relative z-10">
      <div className="absolute inset-0 z-20 pointer-events-none">
        <MagicParticles />
      </div>
      <Header scrollRef={scrollRef} backgroundColor="bg-eryndra-burgundy/20" />

      {/* Hero */}
      <motion.section className="relative bg-eryndra-nosotras bg-cover bg-center text-center py-64"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}>
        <h1 className="font-title text-5xl md:text-8xl  mb-4  tracking-widest text-shadow-lg">SOBRe NOSOTRAS</h1>
        <p className="text-lg md:text-2xl  text-shadow-DEFAULT">
          El corazón mágico detrás de cada evento inolvidable.
        </p>
      </motion.section>

      {/* Historia */}
      <section className="bg-eryndra-ivory/10 py-20 px-6">
        <motion.div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 1, duration: 1 }}>
          <div>
            <h2 className="text-3xl font-cinzel text-eryndra-gold uppercase mb-4">Cómo empezó todo</h2>
            <p className="font-bellefair text-lg leading-relaxed mb-6">
              Eryndra nace del deseo de devolver la fantasía a lo cotidiano. Somos tres amigas que creen en los cuentos, la comunidad y la emoción de crear experiencias únicas.
              Lo que empezó como un sueño hoy es un proyecto lleno de magia y conexión.
            </p>

            <h3 className="text-3xl font-font-cinzel text-eryndra-gold uppercase mb-2">Nuestra misión</h3>
            <p className="font-bellefair text-lg mb-4">
              Crear eventos donde lo imaginario y lo real se entrelacen, ofreciendo a cada persona una vivencia única e inolvidable.
            </p>

            <h3 className="text-3xl font-cinzel text-eryndra-gold uppercase mb-2">Nuestros valores</h3>
            <ul className="list-disc list-inside font-bellefair text-lg space-y-1">
              <li>Creatividad sin límites</li>
              <li>Autenticidad en cada detalle</li>
              <li>Compromiso con la experiencia</li>
              <li>Magia compartida</li>
            </ul>
          </div>

          <img src="/img/amigas.jpg" alt="Equipo Eryndra" className="rounded-xl shadow-lg" />
        </motion.div>
      </section>

      <motion.section className="relative bg-eryndra-burgundy text-eryndra-ivory py-24 px-4 overflow-hidden"
      >


        <h2 className="text-center text-4xl md:text-5xl font-cinzel text-eryndra-gold uppercase mb-24 relative z-10">
          El equipo de Eryndra
        </h2>

        <div className="relative mt-20 flex justify-center items-center gap-10">
          <div className="w-full">
            <div className="relative mt-20 w-full flex justify-center items-center">
              {team.map((member, i) => {
                const pos = ((i - index + team.length) % team.length); // -1, 0, 1

                let translateX = 0;
                let scale = 1;
                let zIndex = 1;
                let opacity = 1;
                let blur = "blur-none";

                if (pos === 0) {
                  translateX = 0;
                  scale = 1.2;
                  zIndex = 10;
                } else if (pos === 1) {
                  translateX = 150;
                  scale = 0.8;
                  zIndex = 5;
                  opacity = 0.5;
                  blur = "blur-sm";
                } else if (pos === team.length - 1) {
                  translateX = -150;
                  scale = 0.8;
                  zIndex = 5;
                  opacity = 0.5;
                  blur = "blur-sm";
                }


                return (
                  <motion.div
                    key={i}
                    className={`absolute cursor-pointer ${blur}`}
                    animate={{
                      x: translateX,
                      scale: scale,
                      zIndex: zIndex,
                      opacity: opacity,
                    }}
                    transition={{ duration: 0.5 }}
                    onClick={() => {
                      if (i !== index) setIndex(i);
                    }}
                    whileHover={{ scale: 1.15 }}
                  >
                    <img
                      src={member.image}
                      alt={member.name}
                      className="object-cover rounded-full border-4 border-eryndra-gold shadow-lg w-40 h-40 md:w-64 md:h-64"
                    />
                  </motion.div>
                );
              })}
            </div>

          </div>
        </div>

        <div className="mt-44 text-center max-w-xl mx-auto ">

          <motion.div
            key={index}
            className="p-6 bg-eryndra-ivory/10 backdrop-blur-lg rounded-3xl shadow-lg "
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 30 }}
            transition={{ duration: 0.5 }}
          >
            <h3 className="text-3xl font-bold font-cinzel text-eryndra-gold mb-2">
              {team[index].name}
            </h3>
            <p className="uppercase text-sm tracking-widest mb-3">
              {team[index].title}
            </p>
            <p className="font-bellefair text-lg leading-relaxed">
              {team[index].description}
            </p>
          </motion.div>

        </div>
      </motion.section>


      {/* Cierre */}
      <section className="bg-eryndra-hojas2 position-castle text-center py-40 text-eryndra-cream relative overflow-hidden"
      >

        {/* Sección newsletter */}
        <div className=" text-center relative z-10">
          <div className="inline-block border border-eryndra-gold rounded-xl px-10 py-12 bg-eryndra-ivory/10 shadow-md backdrop-blur-xl max-w-2xl w-full">
            <h3 className="text-2xl md:text-4xl text-eryndra-gold font-cinzel mb-4">
              ¿Quieres estar al día con nuestra magia?
            </h3>
            <p className="font-bellefair text-xl text-eryndra-cream mb-6">
              Suscríbete a nuestro boletín y sé la primera en conocer eventos, historias y sorpresas de Eryndra.
            </p>
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 items-center justify-center">
              <input
                type="email"
                placeholder="Tu correo electrónico"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="px-4 py-2 rounded-lg text-eryndra-forest focus:outline-none focus:ring-2 focus:ring-eryndra-gold"
                required
              />
              <button type="submit" className="btn-eryndra">
                Suscribirme
              </button>

            </form>

            <AnimatePresence mode="wait">
            <div className="mt-4">
              {success && (
                <motion.p
                  key="success"
                  className="text-green-600"
                  initial={{ opacity: 0, y: -5 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -5 }}
                  transition={{ duration: 0.4 }}
                >
                  ¡Gracias por suscribirte!
                </motion.p>
              )}
              {error && (
                <motion.p
                  key="error"
                  className="text-red-600"
                  initial={{ opacity: 0, y: -5 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -5 }}
                  transition={{ duration: 0.4 }}
                >
                  {error}
                </motion.p>
              )}
              </div>
            </AnimatePresence>
          </div>
        </div>
      </section>
      <Footer />
    </main>
    //</SimpleBar>
  );
}
